import { render, staticRenderFns } from "./WorkItemEdit.vue?vue&type=template&id=65846586&"
import script from "./WorkItemEdit.vue?vue&type=script&lang=js&"
export * from "./WorkItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./WorkItemEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports